import {AdminProfileDeviceParamsState} from './states/admin-profile-device-params.state';
import {AdminProfileState} from './states/admin-profile.state';

export const adminProfileState = [
    AdminProfileState,
    AdminProfileDeviceParamsState
];
